import {
  Center,
  type CenterProps,
  Spinner,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";

const PandaLoadingIndicator = ({
  centerProps = {},
  message = "Loading...",
  subMessage,
  fullScreen = true,
}: {
  centerProps?: CenterProps;
  message?: string;
  subMessage?: string;
  fullScreen?: boolean;
}) => {
  // Background and spinner color reactive to theme
  // const bg = useColorModeValue("#FAFAFA", "#262B33"); // light: soft off-white, dark unchanged
  const spinnerColor = useColorModeValue("#F97316", "#f47433"); // light: primary orange, dark unchanged
  const textColor = useColorModeValue("gray.700", "gray.100");
  const subTextColor = useColorModeValue("gray.500", "gray.300");

  return (
    <Center
      height={fullScreen ? "100vh" : "100%"}
      minH={fullScreen ? "100vh" : "160px"}
      bg="transparent"
      {...centerProps}
    >
      <VStack spacing={3}>
        <Spinner size="xl" color={spinnerColor} />
        <Text color={textColor} fontWeight="600">
          {message}
        </Text>
        {subMessage ? (
          <Text color={subTextColor} fontSize="sm" textAlign="center">
            {subMessage}
          </Text>
        ) : null}
      </VStack>
    </Center>
  );
};

export default PandaLoadingIndicator;
